import React, { useState } from "react";
import QueryList from "./Query/QueryList";
import Help from "./Help/Help";
import SupportList from "./SupportOpen/SupportList";


const HelpAndSupport = () => {
  const [activeComponent, setActiveComponent] = useState("Panel Help & Support")
  // Array with tab names and corresponding components

  const tabs = [
    { name: "Panel Help & Support", component: <Help /> },
    { name: "Non-user Help", component: <SupportList /> },
    { name: "Query Type List", component: <QueryList /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]">
        <h1 className="text-xl m-4 font-semibold">Help And Support</h1>
        <div className="flex space-x-4 mb-6 max-w-100">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`px-4 py-2 rounded-lg text-sm border-b-2 ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default HelpAndSupport;
